"use strict";
import { providers as ethersProviders } from "ethers/lib/ethers";
import { getChainInfo } from "features/chains/chainInfo";
import { RPCType, UniverseChainId } from "features/chains/types";
import { Experiments, PrivateRpcProperties } from "features/gating/experiments";
import { getExperimentValue } from "features/gating/hooks";
import {
  FLASHBOTS_DEFAULT_REFUND_PERCENT,
  FlashbotsRpcProvider
} from "features/providers/FlashbotsRpcProvider";
import { logger } from "utilities/src/logger/logger";
export const DEFAULT_FLASHBOTS_ENABLED = true;
export function createEthersProvider(chainId, rpcType = RPCType.Public, signerInfo) {
  try {
    if (rpcType === RPCType.Private) {
      const privateRPCUrl = getChainInfo(chainId).rpcUrls?.[RPCType.Private]?.http[0];
      if (!privateRPCUrl) {
        throw new Error(`No private RPC available for chain ${chainId}`);
      }
      const flashbotsEnabled = getExperimentValue(
        Experiments.PrivateRpc,
        PrivateRpcProperties.FlashbotsEnabled,
        DEFAULT_FLASHBOTS_ENABLED
      );
      if (chainId === UniverseChainId.Mainnet && flashbotsEnabled) {
        const flashbotsRefundPercent = getExperimentValue(
          Experiments.PrivateRpc,
          PrivateRpcProperties.RefundPercent,
          FLASHBOTS_DEFAULT_REFUND_PERCENT
        );
        return new FlashbotsRpcProvider(signerInfo, flashbotsRefundPercent);
      }
      return new ethersProviders.JsonRpcProvider(privateRPCUrl);
    }
    try {
      const publicRPCUrl = getChainInfo(chainId).rpcUrls?.[RPCType.Public]?.http[0];
      if (publicRPCUrl) {
        return new ethersProviders.JsonRpcProvider(publicRPCUrl);
      }
      throw new Error(`No public RPC available for chain ${chainId}`);
    } catch (error) {
      const altPublicRPCUrl = getChainInfo(chainId).rpcUrls?.[RPCType.PublicAlt]?.http[0];
      return new ethersProviders.JsonRpcProvider(altPublicRPCUrl);
    }
  } catch (error) {
    logger.error(error, {
      tags: { file: "createEthersProvider", function: "createProvider" },
      extra: { chainId }
    });
    return null;
  }
}
